module.exports = function getResource(label) {
    const resources = {
        selectAShade: 'Select a Shade',
        next: 'Next'
    };
    return resources[label];
};
